/* Utils */
import { useEffect, useState } from 'react';

/* Store */
import useModalStore from 'Stores/Modals';
import useFurnituresStore from 'Stores/Furnitures';

/* Components */
import Modal from 'Components/Modal';

/* Styles */
import './style.scss';

const ShowFurniture = (props) => {
	const hideModal = useModalStore(state => state.hideModal);
	const [navigation, setNavigation] = useState({ icon: '', action: () => null });
	const [button, setButton] = useState({ label: 'Next', action: null });

	const furnitures = useFurnituresStore(state => state.furnitures);
	const [currentFurniture, setCurrentFurniture] = useState(null);

	const { params: { furnitureid } } = props;

	useEffect(() => {
		setNavigation({ icon: '', action: () => null });
		setButton({ label: 'Fermer', action: () => hideModal() });
	}, []);

	useEffect(() => {
		if (furnitures) {
			const furniture = furnitures.find(item => item.id === furnitureid);
			setCurrentFurniture(furniture);
		}
	}, [furnitures, furnitureid]);

	return (
		<Modal title={currentFurniture && currentFurniture.name} navigation={navigation} button={button}>
			<div className="default-modal wrapper">
				<div className="default-modal-content">
					{ !currentFurniture && <p className="bodyBullet">...</p> }
					{ currentFurniture && (
						<>
							<span className="header2">{currentFurniture.name}</span>
							{ currentFurniture.stock && (
								<p className="bodyBullet">
									Stock : {currentFurniture.stock.number}
								</p>
							)}
						</>
					)}
				</div>
			</div>
		</Modal>
	);
};

ShowFurniture.propTypes = {
	params: PropTypes.shape({
		furnitureid: PropTypes.string.isRequired
	}).isRequired
};

export default ShowFurniture;
